import moment from "moment";
const fromJson = (item) => {
    return {
        fullName : item.fullName,
        phone  :  item.phone,
        email  :  item.email,
        serviceInfoId : item.serviceInfoId,
        domainCode :  item.domainCode,
        domainName  : item.domainName,
        administrationCode : item.administrationCode,
        administrationName : item.administrationName,
        maxLevel : item.maxLevel,
        content :  item.content,
        CitizenId : item.CitizenId,
        CodeQuestion :  item.CodeQuestion,
        UngDungCode : item.UngDungCode,
    }
}

const baseJson = (ungDungCode) => {
    return {
        fullName : null,
        phone  :  null,
        email  :  null,
        serviceInfoId : null,
        domainCode :  null,
        domainName  : null,
        administrationCode : null,
        administrationName : null,
        maxLevel : null,
        serviceCode : null,
        serviceCodeDVCQG : null,
        content :  null,
        CitizenId : null,
        CodeQuestion :  null,
        UngDungCode : ungDungCode,
    }
}

const baseChildJson = (item) => {
    return {
        fullName : item.fullName,
        phone  :  item.phone,
        email  :  item.email,
        serviceInfoId : item.serviceInfoId,
        domainCode :  item.domainCode,
        domainName  : item.domainName,
        administrationCode : item.administrationCode,
        administrationName : item.administrationName,
        serviceCode : item.serviceCode,
        CitizenId : item.CitizenId,
        serviceCodeDVCQG : item.serviceCodeDVCQG,
        maxLevel : item.maxLevel,
        content :  null,
        CodeQuestion :  item.CodeQuestion,
        UngDungCode : "00",
    }
}

const toListModel = (items) =>{
    if(items.length > 0){
        let data = [];
        items.map((value, index) =>{
            data.push(fromJson(value));
        })
        return data??[];
    }
    return [];
}

export const questionModel = {
   fromJson, baseJson, toListModel , baseChildJson
}
